import { observer } from 'mobx-react-lite'
import { IconButton } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { ContactCard } from 'entities/Contacts'
import { ConversationRoutes } from 'entities/ExportRouters'
import { useConversationSearchContext } from 'pages/conversations/ui/ConversationHeaderSearch/context/conversationSearchContext'
import styles from './styles.module.scss'

export const MobileSearch = observer(() => {
  const { searchDropdownStore, clear, onClose, isHide, clearFilters } =
    useConversationSearchContext()
  const onBack = () => {
    clear(false)
    onClose()
    clearFilters()
    uiStore.changeRoute({
      path: `/${ConversationRoutes.root}`,
    })
  }
  if (!isHide && searchDropdownStore.searchDropdownContactsStore.selectedItems.length) {
    return (
      <div className={styles.wrap}>
        <IconButton
          ariaLabel={'back'}
          color={'secondary'}
          variant={'icon'}
          icon={'chevronLeft'}
          onClick={onBack}
        />
        {searchDropdownStore.searchDropdownContactsStore.selectedItems.map((contact) => (
          <ContactCard key={contact.id} item={contact} size={'mini'} />
        ))}
      </div>
    )
  }
  return null
})
